import React, { useEffect } from 'react';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import './App.css';
import rootReducer from "./reducers/index";
import AppContainer from './AppContainer';

const store = createStore(rootReducer, applyMiddleware(thunk));

// For local dev reload on save: ./bin/webpack-dev-server
const App = () => {
  return (
    <Provider store={store}>
      <AppContainer />
    </Provider>
  )
}

export default App;
